import { render, staticRenderFns } from "./BodyAnatomyForm.vue?vue&type=template&id=141d5860&"
import script from "./BodyAnatomyForm.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports